import type { Conversation, ConversationSummary } from "@/types";

/** Derive the lightweight list-view shape from a full conversation record. */
export function toConversationSummary(c: Conversation): ConversationSummary {
  return {
    id: c.id,
    title: c.title,
    createdAt: c.createdAt,
    updatedAt: c.updatedAt,
    modelId: c.modelId,
    messageCount: c.messages.length,
    workspaceId: c.workspaceId,
    pinned: c.pinned,
    folderId: c.folderId,
  };
}
